import { CapoPlugin } from "/Users/lysis/Documents/html/esoteric/app_dir/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];